import { useDebounce } from '@chiroup/hooks/useDebounce';
import { useState } from 'react';
import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import eventLogService, { EventLogClinic } from '../services/eventLog.service';

const useEventLogClinics = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [planFilter, setPlanFilter] = useState<string[]>([]);
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const debouncedSearch = useDebounce(searchQuery);

  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: EventLogClinic[]; skip?: number; count: number }>(
    ['eventLogClinics', debouncedSearch, planFilter, statusFilter],
    (context: QueryFunctionContext) => {
      return eventLogService.listClinics({
        skip: context.pageParam,
        search: debouncedSearch || undefined,
        plan: planFilter.length > 0 ? planFilter.join(',') : undefined,
        status: statusFilter.length > 0 ? statusFilter.join(',') : undefined,
      });
    },
    {
      getNextPageParam: lastGroup => lastGroup?.skip || undefined,
      refetchOnWindowFocus: false,
    }
  );

  const onSearch = (val: string) => {
    setSearchQuery(val);
  };

  const onPlanFilterChange = (plans: string[]) => {
    setPlanFilter(plans);
  };

  const onStatusFilterChange = (statuses: string[]) => {
    setStatusFilter(statuses);
  };

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    onSearch,
    onPlanFilterChange,
    onStatusFilterChange,
    searchQuery,
    planFilter,
    statusFilter,
  };
};

export default useEventLogClinics;
